import SelectMember from './select-member.vue'

export default SelectMember


// WEBPACK FOOTER //
// ./src/components/business/select-member/index.js